import RingTheme, { applyTheme } from '@jetbrains/ring-ui/dist/global/theme.js';
import { Theme } from '../components/ThemeContext.js';

var isDark = function isDark(theme) {
  return theme === Theme.dark;
};
var isAuto = function isAuto(theme) {
  return theme === Theme.auto;
};
var getCurrentThemeColor = function getCurrentThemeColor(theme, systemTheme) {
  if (isAuto(theme) && systemTheme) {
    return systemTheme;
  } else {
    return theme;
  }
};
var isMatchMediaAvailable = function isMatchMediaAvailable() {
  return typeof window !== 'undefined' && !!window.matchMedia;
};
var getSystemColorScheme = function getSystemColorScheme() {
  if (!isMatchMediaAvailable()) {
    return Theme.light;
  }
  return window.matchMedia('(prefers-color-scheme: dark)').matches ? Theme.dark : Theme.light;
};
var updateMetaThemeColor = function updateMetaThemeColor(currentTheme, color, metaRef) {
  if (isAuto(currentTheme)) {
    if (metaRef.current && document.head.contains(metaRef.current)) {
      document.head.removeChild(metaRef.current);
      metaRef.current = null;
    }
  } else {
    if (metaRef.current) {
      var _metaRef$current;
      (_metaRef$current = metaRef.current) === null || _metaRef$current === void 0 ? void 0 : _metaRef$current.setAttribute('content', color);
    } else {
      var predefinedMetaThemeColors = document.querySelectorAll('meta[name="theme-color"]');
      var meta = document.createElement('meta');
      meta.name = 'theme-color';
      meta.content = color;
      metaRef.current = meta;
      if (predefinedMetaThemeColors.length === 2) {
        predefinedMetaThemeColors[0].before(meta);
      }
    }
  }
};
var updateBodyClass = function updateBodyClass(currentTheme) {
  var _document = document,
    body = _document.body;
  body.classList.add('bodyQodanaBlocks');
  if (isDark(currentTheme)) {
    body.classList.add('bodyQodanaBlocks_dark');
    applyTheme(RingTheme.DARK, body);
  } else {
    body.classList.remove('bodyQodanaBlocks_dark');
    applyTheme(RingTheme.LIGHT, body);
  }
};

export { getCurrentThemeColor, getSystemColorScheme, isAuto, isDark, isMatchMediaAvailable, updateBodyClass, updateMetaThemeColor };
